import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const DigiLockerCallback = () => {
    const location = useLocation();
    const hasSentRef = useRef(false);

    useEffect(() => {
        if (hasSentRef.current) return;
        hasSentRef.current = true;

        const queryParams = new URLSearchParams(location.search);
        const code = queryParams.get('code');
        const state = queryParams.get('state');

        const messageData = code
            ? { type: 'DIGILOCKER_CODE', code, state }
            : { type: 'DIGILOCKER_ERROR', error: 'DigiLocker permission denied or code missing.' };

        // 1. Post to opener if window.opener exists
        if (window.opener) {
            try {
                window.opener.postMessage(messageData, '*');
            } catch (e) {
                console.error('Failed to postMessage to opener:', e);
            }
        }

        // 2. Broadcast via BroadcastChannel (for cases where window.opener is null due to COOP)
        try {
            const channel = new BroadcastChannel('digilocker_channel');
            channel.postMessage(messageData);
            setTimeout(() => channel.close(), 1000);
        } catch (e) {
            console.error('BroadcastChannel failed:', e);
        }

        // 3. Fallback via localStorage storage event
        try {
            localStorage.setItem('digilocker_event', JSON.stringify({
                ...messageData,
                timestamp: Date.now()
            }));
        } catch (e) {
            console.error('localStorage event failed:', e);
        }

        // Close popup window after a brief delay to ensure events emit
        setTimeout(() => {
            try {
                window.close();
            } catch (e) {
                console.error('Failed to close popup:', e);
            }
        }, 500);
    }, [location]);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            backgroundColor: '#f8fafc',
            color: '#475569',
            textAlign: 'center',
            padding: '20px'
        }}>
            <div>
                <div className="spinner-border text-primary mb-3" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <h4 style={{ fontWeight: '600', color: '#0f172a', fontSize: '1.1rem' }}>Completing DigiLocker Authorization...</h4>
                <p style={{ fontSize: '0.875rem', color: '#64748b' }}>Closing popup and returning to dashboard...</p>
            </div>
        </div>
    );
};

export default DigiLockerCallback;

